function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { theme, typography } from '@arc/frontend/ui-theme';
const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "14tj2fa",
    styles: "display:flex;align-items:center;justify-content:center;width:100%;height:5rem"
  } : {
    name: "1vys3gv-container",
    styles: "display:flex;align-items:center;justify-content:center;width:100%;height:5rem;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  icon: /*#__PURE__*/css({
    width: '100%',
    height: '100%',
    color: theme.colors.text.hint
  }, process.env.NODE_ENV === "production" ? "" : ";label:icon;"),
  message: /*#__PURE__*/css(typography.emptyLarge, "text-align:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:message;"))
};
export function EmptyRow(props) {
  return <div css={[styles.container, props.outerStyle, process.env.NODE_ENV === "production" ? "" : ";label:EmptyRow;"]} data-testid="empty-row">
			<props.Icon css={[styles.icon, props.iconStyle, process.env.NODE_ENV === "production" ? "" : ";label:EmptyRow;"]} />
			{props.message ? <div css={[styles.message, props.messageStyle, process.env.NODE_ENV === "production" ? "" : ";label:EmptyRow;"]}>{props.message}</div> : null}
		</div>;
}